import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Banknote, Zap, Smartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './AboutServicesSection.scss';

const SERVICE_ICONS = [Truck, Banknote, Zap, Smartphone];
const SERVICE_COLORS = ['#00ADEF', '#0891b2', '#f43f5e', '#f97316'];
const SERVICE_LINKS = ['/dich-vu/chuyen-phat', '/dich-vu/cod', '/dich-vu/hoa-toc', '/dich-vu/theo-doi'];

const AboutServicesSection: React.FC = () => {
  const { t } = useTranslation();
  const services = t('trangChu.about.services', { returnObjects: true }) as { title: string; desc: string }[];

  return (
    <section className="svc" aria-label={t('trangChu.about.svcLabel')} data-reveal data-anim="up">
      <div className="svc__container">

        {/* Left: brand text */}
        <div className="svc__left" data-reveal data-anim="left">
          <span className="svc__eyebrow">{t('trangChu.about.eyebrow')}</span>
          <h2 className="svc__heading">{t('trangChu.about.headingPrefix')} <span className="svc__brand">Giao Hàng Thông Minh</span></h2>
          <div className="svc__rule" aria-hidden="true" />
          <p className="svc__para">{t('trangChu.about.body1')}</p>
          <p className="svc__para">{t('trangChu.about.body2')}</p>
        </div>

        {/* Right: dashed timeline */}
        <div className="svc__timeline" data-stagger>
          {services.map((s, i) => (
            <Link key={i} to={SERVICE_LINKS[i]} className="svc__item">
              <div className="svc__item-dot" style={{ background: SERVICE_COLORS[i] }}>
                {React.createElement(SERVICE_ICONS[i], { size: 18, strokeWidth: 2 })}
              </div>
              <div className="svc__item-content">
                <strong className="svc__item-title">{s.title}</strong>
                <p className="svc__item-desc">{s.desc}</p>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AboutServicesSection;
